function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M512,97.248c-19.04,8.352-39.328,13.888-60.48,16.576c21.76-12.992,38.368-33.408,46.176-58.016    c-20.288,12.096-42.688,20.64-66.56,25.408C411.872,60.704,384.416,48,354.464,48c-58.112,0-104.896,47.168-104.896,104.992    c0,8.32,0.704,16.32,2.432,23.936c-87.264-4.256-164.48-46.08-216.352-109.792c-9.056,15.712-14.368,33.696-14.368,53.056    c0,36.352,18.72,68.576,46.624,87.232c-16.864-0.32-33.408-5.216-47.424-12.928c0,0.32,0,0.736,0,1.152    c0,51.008,36.384,93.376,84.096,103.136c-8.544,2.336-17.856,3.456-27.52,3.456c-6.72,0-13.504-0.384-19.872-1.792    c13.6,41.568,52.192,72.128,98.08,73.12c-35.712,27.936-81.056,44.768-130.144,44.768c-8.608,0-16.864-0.384-25.12-1.44    C46.496,446.88,101.6,464,161.024,464c193.152,0,298.752-160,298.752-298.688c0-4.64-0.16-9.12-0.384-13.568    C480.224,136.96,497.728,118.496,512,97.248z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.92263ca0.svg";
export { ForwardRef as ReactComponent };